/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIAllInOneUser } from './APIAllInOneUser';
import {
    APIAllInOneUserFromJSON,
    APIAllInOneUserFromJSONTyped,
    APIAllInOneUserToJSON,
} from './APIAllInOneUser';

/**
 * 
 * @export
 * @interface APIPaginatedAllInOneUserList
 */
export interface APIPaginatedAllInOneUserList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedAllInOneUserList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedAllInOneUserList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedAllInOneUserList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIAllInOneUser>}
     * @memberof APIPaginatedAllInOneUserList
     */
    results: Array<APIAllInOneUser>;
}

/**
 * Check if a given object implements the APIPaginatedAllInOneUserList interface.
 */
export function instanceOfAPIPaginatedAllInOneUserList(value: object): value is APIPaginatedAllInOneUserList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedAllInOneUserListFromJSON(json: any): APIPaginatedAllInOneUserList {
    return APIPaginatedAllInOneUserListFromJSONTyped(json, false);
}

export function APIPaginatedAllInOneUserListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedAllInOneUserList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIAllInOneUserFromJSON)),
    };
}

export function APIPaginatedAllInOneUserListToJSON(value?: APIPaginatedAllInOneUserList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIAllInOneUserToJSON)),
    };
}

